var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[(_vm.breadcrumb)?_c('MyBreadcrumb'):_vm._e(),_c('div',{ref:"templateContent",staticClass:"template-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }